var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"header":"Download a report now"}},[(_vm.$store.getters['generatePDF'])?_c('GenerateReport'):_vm._e(),_c('img',{attrs:{"src":"/static/report/get_report.svg","alt":"get report image"}}),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.onClick()}}},[_vm._v("Download report")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }